module.exports = __webpack_public_path__ + "static/media/auto_sub.b3d00b9e.svg";